module.exports = __webpack_public_path__ + "0be0152cedfbd337ca09d74f79f74bcb.jpg";